import { render } from "./InputIdentify.vue?vue&type=template&id=54da5059"
import script from "./InputIdentify.vue?vue&type=script&lang=js"
export * from "./InputIdentify.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__